/*
|--------------------------------------------------------------------------
| Keys
|--------------------------------------------------------------------------
*/

const TOKEN_KEY = "accessToken";

const REFRESH_TOKEN_KEY = "refreshToken";

const USER_KEY = "user";

/*
|--------------------------------------------------------------------------
| Save Access Token
|--------------------------------------------------------------------------
*/

export const saveToken = (token) => {

    localStorage.setItem(TOKEN_KEY, token);

};

/*
|--------------------------------------------------------------------------
| Get Access Token
|--------------------------------------------------------------------------
*/

export const getToken = () => {

    return localStorage.getItem(TOKEN_KEY);

};

/*
|--------------------------------------------------------------------------
| Remove Access Token
|--------------------------------------------------------------------------
*/

export const removeToken = () => {

    localStorage.removeItem(TOKEN_KEY);

};

/*
|--------------------------------------------------------------------------
| Refresh Token
|--------------------------------------------------------------------------
*/

export const saveRefreshToken = (token) => {

    localStorage.setItem(

        REFRESH_TOKEN_KEY,

        token

    );

};

export const getRefreshToken = () => {

    return localStorage.getItem(

        REFRESH_TOKEN_KEY

    );

};

export const removeRefreshToken = () => {

    localStorage.removeItem(

        REFRESH_TOKEN_KEY

    );

};

/*
|--------------------------------------------------------------------------
| User
|--------------------------------------------------------------------------
*/

export const saveUser = (user) => {

    localStorage.setItem(

        USER_KEY,

        JSON.stringify(user)

    );

};

export const getUser = () => {

    const user = localStorage.getItem(USER_KEY);

    return user ? JSON.parse(user) : null;

};

export const removeUser = () => {

    localStorage.removeItem(USER_KEY);

};

/*
|--------------------------------------------------------------------------
| Clear Everything
|--------------------------------------------------------------------------
*/

export const clearAuthStorage = () => {

    removeToken();

    removeRefreshToken();

    removeUser();

};